export const bloodComponents = [
  'Whole Blood', 'Packed Cells', 'Platelets', 'Fresh Frozen Plasma', 'Cryoprecipitate'
];

export const labs = ['CBC', 'PT/INR', 'Electrolytes', 'Crossmatch'];
export const imaging = ['X-Ray', 'CT', 'MRI', 'Echo'];
export const antibiotics = ['Cefazolin', 'Cefuroxime', 'Ampicillin', 'Vancomycin'];
export const antiseptics = ['Povidone-iodine', 'Chlorhexidine'];
export const bridgingPlans = ['LMWH', 'Heparin Infusion', 'None'];
export const positioningOptions = ['Supine', 'Prone', 'Lateral', 'Lithotomy'];

export const bloodGroups = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];

export const commonNames = [
  'Rajesh Kumar', 'Priya Sharma', 'Arjun Patel', 'Sneha Reddy', 'Vikram Singh',
  'Anitha Krishnan', 'Suresh Gupta', 'Meera Nair', 'Karthik Iyer', 'Divya Joshi'
];

export const surgeryData = [
  {
    icd10Code: "K80.0",
    diagnosisDescription: "Calculus of gallbladder with acute cholecystitis",
    procedureCode: "47562",
    procedureDescription: "Laparoscopic cholecystectomy"
  },
  {
    icd10Code: "K35.80",
    diagnosisDescription: "Acute appendicitis",
    procedureCode: "44950",
    procedureDescription: "Appendectomy"
  },
  {
    icd10Code: "N20.0",
    diagnosisDescription: "Kidney stone",
    procedureCode: "50590",
    procedureDescription: "Lithotripsy, extracorporeal"
  },
  {
    icd10Code: "M17.11",
    diagnosisDescription: "Osteoarthritis of right knee",
    procedureCode: "27447",
    procedureDescription: "Total knee arthroplasty (replacement)"
  },
  {
    icd10Code: "M16.11",
    diagnosisDescription: "Osteoarthritis of right hip",
    procedureCode: "27130",
    procedureDescription: "Total hip replacement"
  },
  {
    icd10Code: "C50.911",
    diagnosisDescription: "Breast cancer, right breast",
    procedureCode: "19301",
    procedureDescription: "Lumpectomy"
  },
  {
    icd10Code: "I25.10",
    diagnosisDescription: "Coronary artery disease",
    procedureCode: "33533",
    procedureDescription: "Coronary artery bypass grafting (CABG), single"
  },
  {
    icd10Code: "D25.0",
    diagnosisDescription: "Submucous uterine fibroid",
    procedureCode: "58150",
    procedureDescription: "Total abdominal hysterectomy"
  },
  {
    icd10Code: "K40.20",
    diagnosisDescription: "Inguinal hernia",
    procedureCode: "49505",
    procedureDescription: "Repair of inguinal hernia, initial"
  },
  {
    icd10Code: "L03.115",
    diagnosisDescription: "Cellulitis of right lower limb",
    procedureCode: "11042",
    procedureDescription: "Debridement, skin and subcutaneous tissue"
  },
  {
    icd10Code: "S82.201A",
    diagnosisDescription: "Fracture of tibia shaft",
    procedureCode: "27758",
    procedureDescription: "Open treatment of tibial shaft fracture"
  }
];

export const roomNumbers = [
  'OT-1', 'OT-2', 'OT-3', 'OT-4', 'OT-5',
  'ICU-1', 'ICU-2', 'Recovery-1', 'Recovery-2'
];

export const surgeonList = [
  { id: 101, name: "Dr. Alice Smith" },
  { id: 102, name: "Dr. John Doe" },
  { id: 103, name: "Dr. Rachel Green" },
  { id: 104, name: "Dr. Ross Geller" },
  { id: 105, name: "Dr. Monica Geller" },
  { id: 106, name: "Dr. Chandler Bing" },
  { id: 107, name: "Dr. Joey Tribbiani" },
  { id: 108, name: "Dr. Sheldon Cooper" },
  { id: 109, name: "Dr. Leonard Hofstadter" },
  { id: 110, name: "Dr. Amy Farrah Fowler" },
];
